import { createContext } from "react";

// A separate collector for each build-time render; never shared between pages.
export const SeoContext = createContext(null);
